export const FETCH_APP_USER_CARE_TEAM = 'FETCH_APP_USER_CARE_TEAM';
export const FETCH_APP_USER_CARE_TEAM_SUCCESS = 'FETCH_APP_USER_CARE_TEAM_SUCCESS';
export const FETCH_APP_USER_CARE_TEAM_FAILED = 'FETCH_APP_USER_CARE_TEAM_FAILED';

export const FETCH_APP_USER_PATHWAY_CARE_TEAM = 'FETCH_APP_USER_PATHWAY_CARE_TEAM';
export const FETCH_APP_USER_PATHWAY_CARE_TEAM_SUCCESS = 'FETCH_APP_USER_PATHWAY_CARE_TEAM_SUCCESS';
export const FETCH_APP_USER_PATHWAY_CARE_TEAM_FAILED = 'FETCH_APP_USER_PATHWAY_CARE_TEAM_FAILED';

export const CREATE_CARE_TEAM_ROLE = 'CREATE_CARE_TEAM_ROLE';
export const CREATE_CARE_TEAM_ROLE_SUCCESS = 'CREATE_CARE_TEAM_ROLE_SUCCESS';
export const CREATE_CARE_TEAM_ROLE_FAILED = 'CREATE_CARE_TEAM_ROLE_FAILED';

export const CREATE_CARE_TEAM_ROLE_MEMBER = 'CREATE_CARE_TEAM_ROLE_MEMBER';
export const CREATE_CARE_TEAM_ROLE_MEMBER_SUCCESS = 'CREATE_CARE_TEAM_ROLE_MEMBER_SUCCESS';
export const CREATE_CARE_TEAM_ROLE_MEMBER_FAILED = 'CREATE_CARE_TEAM_ROLE_MEMBER_FAILED';

export const CREATE_CARE_TEAM_ROLE_AND_MEMBER = 'CREATE_CARE_TEAM_ROLE_AND_MEMBER';
export const CREATE_CARE_TEAM_ROLE_AND_MEMBER_SUCCESS = 'CREATE_CARE_TEAM_ROLE_AND_MEMBER_SUCCESS';
export const CREATE_CARE_TEAM_ROLE_AND_MEMBER_FAILED = 'CREATE_CARE_TEAM_ROLE_AND_MEMBER_FAILED';

export const EDIT_CARE_TEAM_ROLE_MEMBER = 'EDIT_CARE_TEAM_ROLE_MEMBER';
export const EDIT_CARE_TEAM_ROLE_MEMBER_SUCCESS = 'EDIT_CARE_TEAM_ROLE_MEMBER_SUCCESS';
export const EDIT_CARE_TEAM_ROLE_MEMBER_FAILED = 'EDIT_CARE_TEAM_ROLE_MEMBER_FAILED';

export const DELETE_CARE_TEAM_ROLE = 'DELETE_CARE_TEAM_ROLE';
export const DELETE_CARE_TEAM_ROLE_SUCCESS = 'DELETE_CARE_TEAM_ROLE_SUCCESS';
export const DELETE_CARE_TEAM_ROLE_FAILED = 'DELETE_CARE_TEAM_ROLE_FAILED';

export const DELETE_CARE_TEAM_ROLE_MEMBER = 'DELETE_CARE_TEAM_ROLE_MEMBER';
export const DELETE_CARE_TEAM_ROLE_MEMBER_SUCCESS = 'DELETE_CARE_TEAM_ROLE_MEMBER_SUCCESS';
export const DELETE_CARE_TEAM_ROLE_MEMBER_FAILED = 'DELETE_CARE_TEAM_ROLE_MEMBER_FAILED';

export const FETCH_CARE_TEAM_ASSIGNABLE_ORGANISATION_USERS =
  'FETCH_CARE_TEAM_ASSIGNABLE_ORGANISATION_USERS';
export const FETCH_CARE_TEAM_ASSIGNABLE_ORGANISATION_USERS_SUCCESS =
  'FETCH_CARE_TEAM_ASSIGNABLE_ORGANISATION_USERS_SUCCESS';
export const FETCH_CARE_TEAM_ASSIGNABLE_ORGANISATION_USERS_FAILED =
  'FETCH_CARE_TEAM_ASSIGNABLE_ORGANISATION_USERS_FAILED';

export interface ICareTeamMember {
  id: number;
  appUserId: string;
  primaryAppUserId: string;
  staffOrganisationId: string | null;
  staffUserId: number | null;
  name: string;
  email: string;
  phone: string;
  businessName: string;
  profilePictureImageId?: string | null;
  profilePictureUrl?: string | null;
}

export interface ICareTeamRole {
  id: number;
  name: string;
  description?: string;
  organisationId: string;
  members: ICareTeamMember[];
  createdByType: string;
}
